import { render, staticRenderFns } from "./AsignacionesPtiAltoRiesgoPacienteComponente.vue?vue&type=template&id=a3b6d0a2"
import script from "./AsignacionesPtiAltoRiesgoPacienteComponente.vue?vue&type=script&lang=js"
export * from "./AsignacionesPtiAltoRiesgoPacienteComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports